module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"downloadPDF":"PDF Herunterladen"},"de":{"downloadPDF":"PDF Herunterladen"}}')
  delete Component.options._Ctor
}
